import { escapeAttr, escapeHtml, linkAttrs } from "@emkit/builder-core";
export const BREADCRUMBS_DEFAULTS = {
    items: [
        { id: "b1", label: "Home", href: "/" },
        { id: "b2", label: "Docs", href: "/docs" },
        { id: "b3", label: "Widgets" },
    ],
    separator: "/",
    textColor: "#6b7280",
    linkColor: "#111827",
    emitSchemaOrg: true,
};
export const breadcrumbsWidget = {
    type: "breadcrumbs",
    defaultProps: BREADCRUMBS_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-breadcrumbs" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty — add items in the inspector)</div>`;
        }
        const sep = props.separator ?? "/";
        const text = props.textColor ?? "#6b7280";
        const link = props.linkColor ?? "#111827";
        const emitSchema = props.emitSchemaOrg ?? true;
        const parts = items
            .map((it, i) => {
            const last = i === items.length - 1;
            const node = it.href && !last
                ? `<a href="${escapeAttr(it.href)}"${linkAttrs(it.href)} style="color:${link};text-decoration:none;font-weight:500">${escapeHtml(it.label)}</a>`
                : `<span aria-current="${last ? "page" : "false"}" style="color:${text}">${escapeHtml(it.label)}</span>`;
            const separator = last
                ? ""
                : `<span aria-hidden="true" style="margin:0 8px;color:${text};opacity:0.5">${escapeHtml(sep)}</span>`;
            return `<li style="display:inline-flex;align-items:center">${node}${separator}</li>`;
        })
            .join("");
        const schema = emitSchema
            ? `<script type="application/ld+json">${JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                itemListElement: items.map((it, i) => ({
                    "@type": "ListItem",
                    position: i + 1,
                    name: it.label,
                    ...(it.href ? { item: it.href } : {}),
                })),
            }).replace(/</g, "\\u003c")}</script>`
            : "";
        return `<nav class="emk-breadcrumbs" aria-label="Breadcrumb" style="font-family:inherit;font-size:14px"><ol style="list-style:none;padding:0;margin:0;display:flex;flex-wrap:wrap;align-items:center">${parts}</ol>${schema}</nav>`;
    },
};
//# sourceMappingURL=breadcrumbs.js.map